// extracted by mini-css-extract-plugin
export default {"button":"Pagination_button__c3xMe","display":"Pagination_display__TRXwU"};